"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const menu_style_1 = __importDefault(require("./menu.style"));
const menu_header_1 = __importDefault(require("./menu.header"));
class Menu extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, title, action } = this.props;
            const rootProps = {
                role: 'menu',
                className: classes.root
            };
            return (jsx_runtime_1.jsxs(react_1.Fragment, { children: [jsx_runtime_1.jsx(menu_header_1.default, { title: title, action: action }, void 0),
                    jsx_runtime_1.jsx("ul", Object.assign({}, rootProps, { children: children }), void 0)] }, void 0));
        };
    }
}
exports.Menu = Menu;
Menu.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    title: prop_types_1.default.string,
    action: prop_types_1.default.node
};
Menu.defaultProps = {
    title: null,
    action: null
};
exports.default = react_jss_1.default(menu_style_1.default)(Menu);
//# sourceMappingURL=menu.js.map